import React from 'react'

import { ProductIds } from 'core/application/commons/config'

import useCurrentProduct from '../../../common/hooks/useCurrentProduct'
import GroupDesignBenefit from './groupHra'
import IchraDesignBenefit from './ichra'
import PerksDesignBenefit from './perks'
import QsehraDesignBenefit from './qsehra'

export const DESIGN_BENEFIT_PATH = 'design'

const productBenefitDesign = new Map<number, any>()
productBenefitDesign.set(ProductIds.GroupHraId, <GroupDesignBenefit />)
productBenefitDesign.set(ProductIds.Perks, <PerksDesignBenefit />)
productBenefitDesign.set(ProductIds.QsehraId, <QsehraDesignBenefit />)
productBenefitDesign.set(ProductIds.IchraId, <IchraDesignBenefit />)

const DesignBenefit: React.FC = () => {
  const product = useCurrentProduct()
  return productBenefitDesign.get(product.productId)
}

export default DesignBenefit
